import { getImageUrl } from './getImageUrl'
import { normalizeImageName } from './normalizeImageName'

export const getNetworkImage = (network: string | 'fallback') => {
  if (network === 'fallback') return getImageUrl('networks', 'unknownNetwork')
  return getImageUrl('networks', normalizeImageName('networks', network))
}
